import React, { useState, useEffect } from 'react';
import FontFaceObserver from 'fontfaceobserver';
import { black_icons, white_icons } from '../../icons';
import { initialScale } from '../../Utils/canvasUtils';
import Select, { components } from 'react-select';

const LOADLINE_COLORS = [
  { id: 'black', hex: '#000000', name: 'Black' },
  { id: 'white', hex: '#FFFFFF', name: 'White' }
];

const AnimatedNomexSwitch = ({ value, onChange }) => {
  const framePath = "M36,2c5.51,0,10,4.49,10,10s-4.49,10-10,10H12c-5.51,0-10-4.49-10-10S6.49,2,12,2h24M36,0H12C5.37,0,0,5.37,0,12H0C0,18.63,5.37,24,12,24h24c6.63,0,12-5.37,12-12h0C48,5.37,42.63,0,36,0h0Z";
  const number1Path = "M13.13,15.59c0,.55-.44.99-.99.99s-.99-.44-.99-.99v-6.29l-.7.18c-.1.03-.25.05-.35.05-.47,0-.87-.39-.87-.86,0-.4.26-.74.66-.86l1.29-.38c.38-.1.66-.17.94-.17h.03c.55,0,.99.44,.99.99v7.33Z";
  const number2Path = "M32.79,14.55l2.59-2.12c1.13-.92,1.57-1.43,1.57-2.18s-.51-1.18-1.22-1.18c-.57,0-.98.25-1.48.79-.13.14-.36.29-.68.29-.51,0-.91-.4-.91-.91,0-.22.09-.46.23-.62.73-.85,1.59-1.34,2.96-1.34,1.88,0,3.13,1.1,3.13,2.81v.03c0,1.52-.78,2.27-2.39,3.52l-1.48,1.14h3.17c.48,0,.87.39.87.87s-.39.86-.87.86h-4.94c-.62,0-1.08-.35-1.08-.95,0-.39.18-.73.52-1Z";

  return (
    <div style={{ width: '48px', height: '24px', cursor: 'pointer' }} onClick={onChange}>
      <svg viewBox="0 0 48 24" style={{ width: '100%', height: '100%' }}>
        <path d={framePath} fill="#fff" />
        <circle
          cx="12" cy="12" r="8.5" fill="var(---e6ab00-hover-color)"
          style={{
            transform: `translateX(${value === 1 ? 0 : 23.76}px)`,
            transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        />
        <path
          d={number1Path}
          fill={value === 1 ? "var(--k-900-303030)" : "#fff"}
          style={{ transition: 'fill 0.3s' }}
        />
        <path
          d={number2Path}
          fill={value === 2 ? "var(--k-900-303030)" : "#fff"}
          style={{ transition: 'fill 0.3s' }}
        />
      </svg>
    </div>
  );
};

function ContextToolBar({
  selectedTool, selectedColor,
  setSelectedColor, selectedNomexColor,
  setSelectedNomexColor,
  selectedFabric, highlightColor,
  canvasRef, onClose, setShowModal, nomexRows,
  loadlinesColor, setLoadlinesColor
}) {
  const [currentHoverColor, setCurrentHoverColor] = useState(null);
  const [curentTextStyle, setCurentTextStyle] = useState({});
  const [fontsLoaded, setFontsLoaded] = useState({});
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    const mobileCheck = 'ontouchstart' in window;
    setIsMobile(mobileCheck);
  }, []);


  const loadFont = (newTextStyle) => {
    if (!fontsLoaded[newTextStyle.fontFamily + newTextStyle.fontWeight + newTextStyle.fontStyle]) {
      const font = new FontFaceObserver(newTextStyle.fontFamily, { weight: newTextStyle.fontWeight, style: newTextStyle.fontStyle });
      font.load().then(() => {
        setFontsLoaded(prevFonts => ({ ...prevFonts, [newTextStyle.fontFamily + newTextStyle.fontWeight + newTextStyle.fontStyle]: true }));
        setCurentTextStyle(newTextStyle);
      });
    } else {
      setCurentTextStyle(newTextStyle)
    }
  };
  useEffect(() => {
    loadFont({ fontFamily: 'Roboto', fontWeight: 'normal', fontStyle: 'normal', fill: '#000000' });
  }, []);

  const handleCurrentTextStyleChange = (newTextStyle) => {
    loadFont(newTextStyle);
  };

  useEffect(() => {
    if (canvasRef.current) {
      canvasRef.current.updateText(curentTextStyle)
    }
  }, [curentTextStyle])

  useEffect(() => {
    if (selectedTool === "Paravent") {
      setShowModal(true);
    }
  }, [selectedTool])


  const handleAddClick = () => {
    if (selectedTool === "Text") {
      canvasRef.current.addText(curentTextStyle);
    }
    else {
      setShowModal(true);
    }
  };

  const handleRemoveClick = () => {
    if (selectedTool === "Paravent") {
      canvasRef.current.removeLogo();
    } else {
      canvasRef.current.removeObject();
    }
  }

  const handleCloneClick = () => {
    canvasRef.current.cloneObject();
  }

  const Placeholder = (props) => (
    <components.Placeholder {...props}>
      Choose
    </components.Placeholder>
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '24px',
      height: '24px',
      width: '100%',
      fontSize: '13px',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: '24px',
      width: '100%',
      padding: '0 6px'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '24px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(---ffffff-white)',
      color: state.isSelected ? 'var(--kb-500-0084cc)' : 'var(--k-900-303030)',
      ':hover': {
        backgroundColor: 'var(---ffffff-white)',
        color: 'var(---e6ab00-hover-color)'
      },
      fontSize: '13px',
    }),
    menu: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      zIndex: 9999
    }),
    menuList: (provided, state) => ({
      ...provided,
      maxHeight: '200px',
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const fontFamilyOptions = [
    { value: 'BalsamicSans', label: 'Balsamic Sans' },
    { value: 'ChakraPetch', label: 'Cahkra Petch' },
    { value: 'CrimsonText', label: 'CrimsonText' },
    { value: 'Mali', label: 'Mali' },
    { value: 'Merriweather', label: 'Merriweather' },
    { value: 'Montserrat', label: 'Montserrat' },
    { value: 'Roboto', label: 'Roboto' },
    { value: 'ZillaSlab', label: 'Zilla Slab' }
  ];

  return (
    <div className="context-tool-bar"
      style={
        { position: 'absolute', bottom: 0, maxWidth: '100vw', width: 'max(772px, 100%)' }
      }
    >
      <div className='tool-grid'>
        {["Panel", "Row", "Gore", "Envelope", "SpiralUp", "Spiral", "Swap"].includes(selectedTool) &&
          selectedFabric.colors.items.map((colorOption) => (
            <div
              key={colorOption.id}
              className={`color-option ${colorOption === selectedColor ? 'selected' : ''} ${highlightColor === colorOption.hex ? 'hovered' : ''}`}
              style={{ backgroundColor: colorOption.hex }}
              onClick={() => setSelectedColor(colorOption)}
              onMouseEnter={() => setCurrentHoverColor(colorOption)}
              onMouseLeave={() => setCurrentHoverColor(null)}
            >
              {(currentHoverColor === colorOption || (highlightColor === colorOption.hex)) && (
                <div className={`color-tooltip`}>
                  {colorOption.name}
                </div>
              )}
            </div>
          ))
        }{["Nomex"].includes(selectedTool) &&
          selectedFabric.nomex.items.map((colorOption) => (
            <div
              key={colorOption.id}
              className={`color-option ${colorOption === selectedNomexColor ? 'selected' : ''}`}
              style={{ backgroundColor: colorOption.hex }}
              onClick={() => {
                setSelectedNomexColor(prevColor => colorOption);
              }

              }
              onMouseEnter={() => setCurrentHoverColor(colorOption)}
              onMouseLeave={() => setCurrentHoverColor(null)}
            >
              {currentHoverColor === colorOption && (
                <div className="color-tooltip">{currentHoverColor.name}</div>
              )}
            </div>
          ))
        }
        {["Loadlines"].includes(selectedTool) &&
          LOADLINE_COLORS.map((colorOption) => (
            <div
              key={colorOption.id}
              className={`color-option ${loadlinesColor === colorOption.hex ? 'selected' : ''}`}
              style={{ backgroundColor: colorOption.hex }}
              onClick={() => setLoadlinesColor(colorOption.hex)}
              onMouseEnter={() => setCurrentHoverColor(colorOption)}
              onMouseLeave={() => setCurrentHoverColor(null)}
            >
              {(currentHoverColor === colorOption) && (
                <div className={`color-tooltip`}>
                  {colorOption.name}
                </div>
              )}
            </div>
          ))
        }
        {
          ["Graphic", "Text", "Paravent"].includes(selectedTool) &&
          <>
            <button className="context-toolbar-button" onClick={handleAddClick}><black_icons.addIcon /><p>ADD</p></button>
            {selectedTool === "Graphic" &&
              <button className="context-toolbar-button" onClick={() => canvasRef.current.addBanner()}><white_icons.bannerIconW /><p>BANNER</p></button>
            }
            {selectedTool !== "Paravent" &&
              <>
                <button className="context-toolbar-button" onClick={handleCloneClick}><black_icons.cloneIcon /><p>CLONE</p></button>
                <button className="context-toolbar-button" onClick={() => canvasRef.current.multiplyObject(2)}><white_icons.clone2xIconW style={{ height: '24px' }} /><p>MULTIPLY</p></button>
                <button className="context-toolbar-button" onClick={() => canvasRef.current.multiplyObject(3)}><white_icons.clone3xIconW style={{ height: '24px' }} /><p>MULTIPLY</p></button>
                <button className="context-toolbar-button" onClick={() => canvasRef.current.multiplyObject(4)}><white_icons.clone4xIconW style={{ height: '24px' }} /><p>MULTIPLY</p></button>
              </>}
            <button className="context-toolbar-button" onClick={handleRemoveClick}><black_icons.removeIcon /><p>REMOVE</p></button>
            {selectedTool === "Text" &&
              <>
                <hr className="separator" />
                <div className='context-toolbar-button'>
                  <Select
                    id="fontFamilySelect"
                    options={fontFamilyOptions}
                    value={fontFamilyOptions.find(option => option.value === curentTextStyle.fontFamily)}
                    onChange={(selectedOption) => handleCurrentTextStyleChange({ ...curentTextStyle, fontFamily: selectedOption.value })}
                    components={{ Placeholder }}
                    styles={customStyles}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    menuPlacement="top"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isSearchable={!isMobile}
                  />
                  <p>FONT FAMILY</p>
                </div >
                <button className={`context-toolbar-button ${curentTextStyle.fontWeight === 'bold' ? 'toggle' : ''}`} onClick={() => handleCurrentTextStyleChange({ ...curentTextStyle, fontWeight: curentTextStyle.fontWeight === 'bold' ? 'normal' : 'bold' })}><black_icons.boldIcon /><p>BOLD</p></button>
                <button className={`context-toolbar-button ${curentTextStyle.fontStyle === 'italic' ? 'toggle' : ''}`} onClick={() => handleCurrentTextStyleChange({ ...curentTextStyle, fontStyle: curentTextStyle.fontStyle === 'italic' ? 'normal' : 'italic' })}><black_icons.italicIcon /><p>ITALIC</p></button>
                <div className='context-toolbar-button'>
                  <input type="color" id="color" value={curentTextStyle.fill} onChange={(e) => handleCurrentTextStyleChange({ ...curentTextStyle, fill: e.target.value })} />
                  <p>SWATCH</p>
                </div>
              </>}
            {selectedTool !== "Paravent" &&
              <button className="context-toolbar-button" onClick={canvasRef.current.bringForward}>
                <span style={{ display: 'inline-block', transform: 'rotate(90deg)' }}>
                  <black_icons.undoIconB />
                </span>
                <p>Forward</p></button>
            }
            {selectedTool !== "Paravent" &&
              <button className="context-toolbar-button" onClick={canvasRef.current.bringBackward}>
                <span style={{ display: 'inline-block', transform: 'rotate(90deg)' }}>
                  <black_icons.redoIconB />
                </span>
                <p>Back</p>
              </button>}
          </>
        }
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {["Nomex"].includes(selectedTool) && (
          <div className="nomex-switch-container" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ fontSize: '13px', fontWeight: 'bold', color: 'white' }}>Nomex panel raws</span>
            <AnimatedNomexSwitch
              value={nomexRows}
              onChange={() => canvasRef.current.setNomexRows(nomexRows === 1 ? 2 : 1)}
            />
          </div>
        )}
        <button className="close-button" onClick={onClose}><black_icons.closeIcon /></button>
      </div>
    </div>
  );
}

export default ContextToolBar;